(function () {
  'use strict';

  angular
      .module('tfc.retailer.ProductDetail')
      .controller('ProductDetailCtrl', ProductDetailCtrl)
      .constant("INCHES_TO_CM", 0.39370)
      .constant("KG_TO_LB", 2.20462);

  // @ngInject
  function ProductDetailCtrl($stateParams, $window, $timeout, $filter, styleSummary, styleSizeAdvice, brands, attributeValues,
                             topBrands, categoryTopBrands, sizeAdvice, consumerHeight, consumerWeight, consumerAgeRange,
                             INCHES_TO_CM, KG_TO_LB, ColorCode, ChartService, Filter) {

    var vm = this;
    vm.brands = brands;
    vm.styleSummary = {};
    angular.copy(styleSummary, vm.styleSummary);
    vm.styleSummary.styleId = $stateParams.styleId;
    vm.selectedBrand = _.find(vm.brands, {key: $stateParams.brandKey});
    vm.offsets = [];
    vm.attributeValues = filterAttributeValues(attributeValues);
    vm.selectedCategoryTopBrands = getBrandsList(categoryTopBrands);
    vm.selectedTopBrands = getBrandsList(topBrands);

    vm.previousState = $stateParams.previousState;
    vm.selectedActivity = $stateParams.transaction;
    vm.selectedRegion = $stateParams.regionDescription;

    vm.goBack = function(){
      $window.history.back();
    };

    vm.styleSummary.sizeAdvice = styleSizeAdvice && styleSizeAdvice.sizeAdvice;
    vm.returnVariation = (vm.styleSummary.returnVariation) ? (vm.styleSummary.returnVariation * 100).toFixed(1) : (_.isEmpty(styleSummary)) ? undefined : "";
    vm.styleSummary.colorClass = ColorCode.getColor(vm.returnVariation);
    var colorClassArr = vm.styleSummary.colorClass.split("-");
    vm.keyClassName = colorClassArr.length > 3 ? colorClassArr[0] + "-" + colorClassArr[1] : colorClassArr[0];

    vm.sizeAdvice = sizeAdvice && sizeAdvice[0];
    vm.chartObject = createChartObject();
    vm.headers = ["", "runsSmall", "trueToSize", "runsLarge"];

    vm.unfilteredData = _(vm.chartObject).map(function(data) {
      return {
        styleName : data.styleName,
        offsetChart: ChartService.getSizeAdviceChart([{sizeAdvice: data.sizeAdvice}])
      }
    }).value();

    vm.consumerDemographicObject = {
      ageRange: consumerAgeRange,
      heightLow: _.filter(consumerHeight, {unit: 'in'}),
      weightLow: _.filter(consumerWeight, {unit: 'lb'})
    };

    vm.consumerDemographicSummary = getDemographicsSummary(vm.consumerDemographicObject);

    if($stateParams.previousState === 'Fit Consistency'){
      vm.styleSummary.styleName = styleSizeAdvice.styleTitle;
      vm.styleSummary.department = vm.sizeAdvice && vm.sizeAdvice.department;
      vm.styleSummary.category = vm.sizeAdvice && vm.sizeAdvice.category;
    }

    function getDemographicsSummary(demographicObject){
      var finalArr = [];
      _.forOwn(demographicObject, function(response) {
        if(response && response.length>0){
          var maxPercentObj = _.maxBy(response, 'percent');
          if(maxPercentObj.ageRange){
            maxPercentObj['range'] = 'age ' + maxPercentObj.ageRange;
          } else if(maxPercentObj.heightLow){
            maxPercentObj['range'] = convertUnits(maxPercentObj.unit, maxPercentObj.heightLow);
          } else if(maxPercentObj.weightLow){
            maxPercentObj['range'] = convertUnits(maxPercentObj.unit, maxPercentObj.weightLow);
          } else {
            maxPercentObj['range'] = '';
          }
          maxPercentObj['percent'] = (maxPercentObj['percent'] * 100).toFixed(1);
          finalArr.push(maxPercentObj);
        }
      });
      return finalArr;
    }

    function convertUnits(unit, value){
      switch(unit){
        case 'in': return value + ' ' + unit + ' / ' + (value/INCHES_TO_CM).toFixed(1) + ' cm';
          break;
        case 'cm': return (value*INCHES_TO_CM).toFixed(1) + ' ' + unit + ' / ' + value + ' cm';
          break;
        case 'kg': return value + ' lb / ' + (value*KG_TO_LB).toFixed(1) + unit;
          break;
        case 'lb': return (value/KG_TO_LB).toFixed(1) + ' kg / ' + value  + ' ' + unit;
          break;
      }
    }

    function filterAttributeValues(collection){
      if(_.isArray(collection)){
      var hash = {};
        collection.forEach(function (item) {
            if (hash[item.attribute]) {
              hash[item.attribute].attributeValue += ', ' + item.attributeValue;
            }
            else {
              hash[item.attribute] = item;
            }
        });
        return _.orderBy(_.values(hash), 'displayOrder');
      }
    }

    function createChartObject(){
      var finalArr = [];
      if(!_.isUndefined(vm.styleSummary.sizeAdvice)) {
        finalArr.push({
          styleName: 'This Style',
          sizeAdvice: vm.styleSummary.sizeAdvice
        });
      }
      if (vm.sizeAdvice && !_.isUndefined(vm.sizeAdvice.sizeAdvice)) {
        finalArr.push({
          styleName: 'Your ' + vm.sizeAdvice.department + "/" + vm.sizeAdvice.category,
          sizeAdvice: vm.sizeAdvice.sizeAdvice
        });
      }
      return finalArr;
    }

    function getBrandsList(arr){
      var newArr = [];
      arr.forEach(function (res) {
        var selectedBrand = _.find(vm.brands, {key: res.affinitybrandKey});
        if(selectedBrand){
          res['name'] = selectedBrand.name;
          newArr.push(res);
        }
      });
      return newArr;
    }

    vm.getFilterSummaryText = function(){
      var pageName = 'productDetail';
      var params = {
        'activity': $filter('titleCase')(vm.selectedActivity),
        'region': vm.selectedRegion
      };
      return Filter.getFilterSummaryText(pageName, params);
    }

  }
})();